import React from 'react';

function ViewModeToggle({ viewMode, onViewModeChange, onlineUsers = [] }) {
  const isCollaborative = viewMode === 'collaborative';
  
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '6px',
      padding: '4px 8px',
      background: 'rgba(255, 255, 255, 0.15)',
      borderRadius: '16px',
      border: '1px solid rgba(255, 255, 255, 0.25)'
    }}>
      {/* Private Mode Icon */}
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          fontSize: '16px',
          opacity: isCollaborative ? 0.6 : 1,
          transition: 'all 0.3s ease',
          cursor: 'pointer',
          filter: 'brightness(1.5) contrast(1.2)'
        }}
        onClick={() => onViewModeChange('private')}
        title="Private Mode - Personal view only"
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.filter = 'brightness(2) contrast(1.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.filter = 'brightness(1.5) contrast(1.2)';
        }}
      >
        🔒
      </div>

      {/* Toggle Switch */}
      <div
        onClick={() => onViewModeChange(isCollaborative ? 'private' : 'collaborative')}
        style={{
          position: 'relative',
          width: '36px',
          height: '18px',
          backgroundColor: isCollaborative ? '#e8f4fd' : '#f0f0f0',
          borderRadius: '9px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          border: `1px solid ${isCollaborative ? '#b3d9ff' : '#d0d0d0'}`,
          boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = isCollaborative ? '#d4eaff' : '#e8e8e8';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = isCollaborative ? '#e8f4fd' : '#f0f0f0';
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: '1px',
            left: isCollaborative ? '19px' : '1px',
            width: '14px',
            height: '14px',
            backgroundColor: isCollaborative ? '#4a90e2' : '#999',
            borderRadius: '50%',
            transition: 'all 0.3s ease',
            boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
          }}
        />
      </div>

      {/* Collaborative Mode Icon with Online Count */}
      <div 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          width: '20px',
          height: '20px',
          fontSize: '16px',
          opacity: isCollaborative ? 1 : 0.6,
          transition: 'all 0.3s ease',
          cursor: 'pointer',
          position: 'relative',
          filter: 'brightness(1.5) contrast(1.2)'
        }}
        onClick={() => onViewModeChange('collaborative')}
        title="Collaborative Mode - Shared workspace with real-time updates"
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.filter = 'brightness(2) contrast(1.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.filter = 'brightness(1.5) contrast(1.2)';
        }}
      >
        🌐
        {/* Online user count badge */}
        {isCollaborative && onlineUsers.length > 1 && (
          <span style={{
            position: 'absolute',
            top: '-4px',
            right: '-4px',
            background: '#4a90e2',
            color: 'white',
            borderRadius: '6px',
            padding: '1px 3px',
            fontSize: '9px',
            fontWeight: 'bold',
            minWidth: '12px',
            height: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid white',
            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
          }}>
            {onlineUsers.length}
          </span>
        )}
      </div>
    </div>
  );
}

export default ViewModeToggle;